import React, { useState } from "react";
import TabbedViewWithDateSelect from "../../components/TabbedViewWithDateSelect/TabbedViewWithDateSelect";
import { JLR_PLANT } from "../../constants";
import { usePlantAndLinesStore } from "../../providers/PlantAndLinesStore/PlantAndLinesStore";
import RfdLimit from "../../components/RfdLimit/RfdLimit";

const RfdLimitConfigurator = () => {
  const [plant] = usePlantAndLinesStore().plantState;

  const [rfdLimitCount, setRfdLimitCount] = useState(0);

  const title = "RFD Limit Configurator";

  return (
    <div>
      <TabbedViewWithDateSelect
        tabs={[
          {
            label: "RFD Limit",
            title,
            count: rfdLimitCount,
            countColor: plant.label === JLR_PLANT ? "green" : "blue",
            backgroundColor: plant.label === JLR_PLANT ? "green" : "blue",
            component: RfdLimit,
            props: {
              handleCountChange: setRfdLimitCount,
            },
          },
        ]}
        pageTitle={title}
      />
    </div>
  );
};

export default RfdLimitConfigurator;
